import { FC, useState } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import { Switcher } from '../switcher/Switcher'

import cl from './LoyaltySlideContent.module.scss'

export interface LoyaltySlideContentProps {
	title: string
	subtitle: string
	getPercent: { value: string[] | string; notation: string[] | string }
	paymentPercent: { value: string; notation: string }
}

export const LoyaltySlideContent: FC<LoyaltySlideContentProps> = props => {
	const { paymentPercent, getPercent, subtitle, title } = props
	const [isChecked, setIsChecked] = useState(false)

	const handleChange = () => {
		setIsChecked(prev => !prev)
	}
	const currentValue = Array.isArray(getPercent.value)
		? isChecked
			? getPercent.value[1]
			: getPercent.value[0]
		: getPercent.value
	const currentNotation = Array.isArray(getPercent.notation)
		? isChecked
			? getPercent.notation[1]
			: getPercent.notation[0]
		: getPercent.notation

	return (
		<>
			<div className={cl.header}>
				<h3>{title}</h3>
				<p dangerouslySetInnerHTML={createMarkup(subtitle)} />
			</div>
			<div className={cl.footer}>
				<div>
					<h4>{currentValue}</h4>
					<p>{currentNotation}</p>
				</div>
				{Array.isArray(getPercent.value) && <Switcher isChecked={isChecked} handleChange={handleChange} />}
				<div>
					<h4 className={cl.value}>{paymentPercent.value}</h4>
					<p>{paymentPercent.notation}</p>
				</div>
			</div>
		</>
	)
}
